module.exports = __webpack_public_path__ + "media/images/card_deck_icon-54f12609.jpg";